export const signup = {
  namespaced: true,
  state: {
    currentStep: 1,
    email: null,
    email_token: null,
    id: null,
    firstname: null,
    lastname: null,
    coupon: null,
    selected_plan: null,
    yearly_plan: null,
    billing_total: null,
    email_pending: false,
    artists: [],
    pixels: [],
    plans: [
      {
        id: "lite_monthly",
        billingDayOfMonth: null,
        billingFrequency: 1,
        currencyIsoCode: "USD",
        name: "Lite (monthly)",
        numberOfBillingCycles: null,
        price: "6.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true
      },
      {
        id: "lite_yearly",
        billingDayOfMonth: null,
        billingFrequency: 12,
        currencyIsoCode: "USD",
        name: "Lite (yearly)",
        numberOfBillingCycles: null,
        price: "60.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true
      },
      {
        id: "pro_monthly",
        billingDayOfMonth: null,
        billingFrequency: 1,
        currencyIsoCode: "USD",
        name: "Pro (monthly)",
        numberOfBillingCycles: null,
        price: "19.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true
      },
      {
        id: "pro_yearly",
        billingDayOfMonth: null,
        billingFrequency: 12,
        currencyIsoCode: "USD",
        name: "Pro (yearly)",
        numberOfBillingCycles: null,
        price: "190.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true
      }
    ]
  },

  actions: {},

  mutations: {
    setData(state, data) {
      state = {
        ...state,
        ...data
      };
    },
    setStep(state, step) {
      state.currentStep = step;
    },
    nextStep(state) {
      state.currentStep++;
    },
    previousStep(state) {
      state.currentStep--;
    },
    setEmail(state, data) {
      state.email = data;
    },
    setEmailCode(state, data) {
      state.email_token = data;
    },
    setEmailPending(state, data) {
      state.email_pending = data;
    },
    setId(state, data) {
      state.id = data;
    },
    setName(state, data) {
      state.firstname = data.firstname;
      state.lastname = data.lastname;
    },
    resetArtists(state) {
      state.artists = [];
    },
    setArtists(state, data) {
      state.artists = data;
    },
    removeArtist(state, artist_id) {
      state.artists = state.artists.filter(x => x.id !== artist_id);
    },
    setCoupon(state, data) {
      state.coupon = data;
    },
    setSelectedPlan(state, data) {
      state.selected_plan = data;
    },
    setIsYearlyPlan(state, data) {
      state.yearly_plan = data;
    },
    setBillingTotal(state, data) {
      state.billing_total = data;
    },
    setPixels(state, data) {
      state.pixels = data;
    },
    reset(state) {
      state.currentStep = 1;
      state.email = null;
      state.email_token = null;
      state.id = null;
      state.firstname = null;
      state.lastname = null;
      state.coupon = null;
      state.selected_plan = null;
      state.yearly_plan = null;
      state.billing_total = null;
      state.artists = [];
      state.pixels = [];
    }
  }
};
